import React, { useContext, useEffect, useState } from 'react';
import css from './style.module.css';
import { AnimatePresence, motion } from 'framer-motion';
import axios from 'axios';
import { MarktingContext } from '../../Context/MarktingContext';
import { useNavigate } from 'react-router-dom';
import { useDocumentInfo } from './hooks';
import HeaderMarketing from '../LoadingPages/HeaderMarketing';
import ActionToast from './ArchivedToats';



export default function Header({
    setArchived, archived,
    documentStatus, setDocumentStatus, id, animationPlayed,
    setAnimationPlayed, setCurrentVersion, filestatus, setDocInfo,
    setFileStatus, setComments, setId, setConvertedHtml, loginToken
}) {

    const { setMarktingData, marktingData, archivedData, setArchivedData, fetchPublicUrl, userTeam } = useContext(MarktingContext);
    const [listToggle, setListToggle] = useState(false);
    const [docData, setDocData] = useState([]);
    const [versionNumber, setVersionNumber] = useState(0);
    // const statusValues = ['Awaiting Review', 'Comments Provided', 'Adjustments Made', 'Active Version'];
    const [spinner, setSpinner] = useState({ archived: false, status: false, sendEmail: false });
    const [appear, setAppear] = useState(false);
    const navigation = useNavigate();

    const { foundItem, version } = useDocumentInfo(id, marktingData, archivedData);

    // 4) Update local state when hook outputs change
    useEffect(() => {
        if (foundItem) {
            setDocData(foundItem);
            setVersionNumber(version);
        }
    }, [foundItem, version]);

    if (!docData) {
        return <HeaderMarketing />;
    }
    // const AutoSetRanking = () => {
    //     const index = statusValues.findIndex((item) => item === documentStatus);
    //     const nextIndex = index + 1;
    //     return nextIndex < statusValues.length ? statusValues[nextIndex] : statusValues[0];
    // };

    const archivedDocument = async (id, archived = true) => {
        if (!id) return;

        // show spinner
        setSpinner(s => ({ ...s, archived: true }));

        try {
            const res = await axios.put(
                `${process.env.REACT_APP_API_URL}/marketing/${id}?field=archived`,
                { archived },
                { headers: { Authorization: `Bearer ${loginToken}` } }
            );

            if (res.status === 200 && archived) {


                // 1) remove from state safely
                setMarktingData(prev =>
                    prev.filter(item => item && item.documentId !== id)
                );


                setArchivedData(prev => [
                    ...prev,
                    res.data.data
                ]);

                // 2) now navigate / show toast
                // alert("Document archived successfully");
                setArchived(true);
                // navigation('/marketingcompliance');
            }
            else if (res.status === 200 && !archived) {

                setArchivedData(prev =>
                    prev.filter(item => item && item.documentId !== id)
                );
                setMarktingData(prev => [
                    ...prev,
                    res.data.data
                ]);
                // alert("Document unarchived successfully");
                setArchived(false);

                // navigation('/setup/archived');
            }
            setAppear(true);
        } catch (error) {
            // console.error("Error updating status:", error);
            if (error?.response?.status === 401) {
                localStorage.removeItem("Firebase Auth");
                localStorage.removeItem("okta-token-storage");
                localStorage.removeItem("okta-cache-storage");
                navigation('/');
                // console.error("session expired");
                return;
            }
        } finally {
            // always hide spinner
            setSpinner(s => ({ ...s, archived: false }));
        }
    };
    const UpdateStatus = async (id) => {
        if (!id) return;
        setSpinner({ ...spinner, status: true });

        try {
            const payload = { status: "Active Version" };
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/marketing/${id}`, payload, {
                headers: {
                    Authorization: `Bearer ${loginToken}`,
                },
            });
            if (res.status === 200) {
                setDocumentStatus(payload.status);
                const deepCopy = [...marktingData];
                const index = deepCopy.findIndex((item) => item.documentId === id);
                if (index !== -1) {
                    deepCopy[index] = res.data.data;
                    setMarktingData(deepCopy);
                    setDocInfo(res.data.data);
                    setFileStatus(null);
                }
                setSpinner({ ...spinner, status: false });
            }
        } catch (error) {
            setSpinner({ ...spinner, status: false });

            if (error?.response?.status === 401) {
                localStorage.removeItem("Firebase Auth");
                localStorage.removeItem("okta-token-storage");
                localStorage.removeItem("okta-cache-storage");
                navigation('/');
                // console.error("seassion expired");
                return;
            };
            // console.error("Error updating status:", error);
        }
    };

    const sendAlaert = async (id) => {
        setSpinner({ ...spinner, sendEmail: true });

        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/send/notification/${id}`, {
                headers: {
                    Authorization: `Bearer ${loginToken}`,
                },
            });
        } catch (error) {
            setSpinner({ ...spinner, sendEmail: false });

            // console.error("Error sending alert:", error);
            if (error?.response?.status === 401) {
                localStorage.removeItem("Firebase Auth");
                localStorage.removeItem("okta-token-storage");
                localStorage.removeItem("okta-cache-storage");
                navigation('/');
                // console.error("session expired");
                return;
            }
            console.log("Error sending alert:", error);
        }
        setSpinner({ ...spinner, sendEmail: false });

    }

    if (docData.length === 0) {
        return <HeaderMarketing />;
    }

    const handleVersionClick = async (version) => {
        const { versionId, documentUrl, convertedBefore } = version;

        const documentUrlTest = typeof documentUrl === "string" ? documentUrl : "";
        const isHtml = [".html", ".htm", "HTML"].some(ext => documentUrlTest.includes(ext));

        setId(versionId);
        if (!isHtml) {
            const publicUrl = await fetchPublicUrl(versionId);
            setCurrentVersion(publicUrl);
        } else {
            setCurrentVersion(documentUrl);
        }
        setConvertedHtml(convertedBefore);
        setVersionNumber(version.versionNumber);

        // Get comments from both active and archived data
        const allComments = [
            ...marktingData.flatMap((item) => [
                ...(item.documentId === versionId ? item.Comments ?? [] : []),
                ...(item.version?.find((v) => v.versionId === versionId)?.Comments ?? []),
            ]),
            ...archivedData.flatMap((item) => [
                ...(item.documentId === versionId ? item.Comments ?? [] : []),
                ...(item.version?.find((v) => v.versionId === versionId)?.Comments ?? []),
            ])
        ];
        // Set comments and ensure it's not immediately overwritten
        setComments(allComments);
    }

    return (
        <>
            {appear ? archived ? <ActionToast variant={"archived"} setAppear={setAppear} /> : <ActionToast variant={"unarchived"} setAppear={setAppear} /> : ""}
            <div className={`container-fluid ${css.documetContainer} py-1`}>
                <div className="row">
                        <div className='col-md-5 d-flex align-items-center justify-content-start '>
                            <p className='text-center my-auto fw-bold fs-5 text-break'>{docData?.documentName} - V{versionNumber ?? versionNumber}</p>
                            {/* versions */}
                            {docData?.version?.length > 0 && <div className='position-relative z-3'>

                                <motion.div
                                    initial={{ rotateX: 0 }}
                                    animate={{ rotateX: listToggle ? 180 : 0 }}
                                    transition={{ duration: 0.9, ease: "easeInOut" }}
                                >
                                    <i className="ms-2 fa-regular fa-square-caret-down fa-xl holdCursor" onClick={() => setListToggle(!listToggle)}></i>
                                </motion.div>

                                <AnimatePresence>
                                    {listToggle && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0, overflow: "hidden" }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{
                                                height: { duration: 0.8, ease: "easeInOut" },
                                                opacity: { duration: 0.5, ease: "easeInOut" },
                                                delayChildren: 0.3,
                                                staggerChildren: 0.1,
                                            }}
                                            className={`${css.versionList} d-flex justify-content-center align-items-center flex-column`}
                                        >
                                            <>
                                                {docData?.version?.sort((a, b) => b.versionNumber - a.versionNumber).map((version) => (
                                                    <p key={version.versionId} className={`m-0 ${css.versionListVersion} w-100 text-center`} onClick={() => handleVersionClick(version)} >Version {version.versionNumber}</p>
                                                ))}
                                                <p className={`m-0 ${css.versionListVersion}  w-100 text-center`} onClick={() => handleVersionClick({ versionId: docData.documentId, documentUrl: docData.documentUrl, versionNumber: 1, convertedBefore: docData.convertedBefore })}  >Version 1</p>
                                            </>
                                        </motion.div>
                                    )}
                                </AnimatePresence>

                            </div>}
                        </div>
                        <div className='col-md-7 d-flex align-items-center justify-content-end'>
                            {!docData?.archived ?
                                <>
                                    {(userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") ? <button className={`btn ${css.statusButton} ${css.headerActionBtn}`} onClick={() => archivedDocument(docData?.documentId)}>Archive
                                        {spinner.archived && <i className='ms-2 fa-solid fa-spinner fa-spin'></i>}
                                    </button> : ""}
                                    {(userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") ? <button className={`btn ${css.statusButton} ${css.headerActionBtn}`} onClick={() => UpdateStatus(docData?.documentId)}>Approve Document
                                        {/* spinner */}
                                        {spinner.status && <i className='ms-2 fa-solid fa-spinner fa-spin'></i>}
                                    </button> : ""}

                                    {(userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") ? <button className={`b-pink-color ${css.headerActionBtn}`} onClick={() => sendAlaert(docData?.documentId)}>Submit for Marketing Review
                                        {spinner.sendEmail && <i className='ms-2 spinner-border spinner-border-sm'></i>}
                                    </button> : ""}
                                    {(userTeam === "marketing") ? <button className={`b-pink-color ${css.headerActionBtn}`} onClick={() => sendAlaert(docData?.documentId)}>Submit for Compliance Review
                                        {spinner.sendEmail && <i className='ms-2 spinner-border spinner-border-sm'></i>}
                                    </button> : ""}
                                    {(userTeam === "marketing" || userTeam === "superAdmin") ? <button
                                        className={`${!animationPlayed ? "b-pink-color" : "btn btn-danger"} ${css.headerActionBtn}`}
                                        onClick={() => setAnimationPlayed(!animationPlayed)}
                                    >
                                        <AnimatePresence mode="wait">
                                            <motion.span
                                                key={animationPlayed ? "cancel" : "add"}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                exit={{ opacity: 0 }}
                                                transition={{ duration: 0.3, ease: "easeInOut" }}
                                            >
                                                {animationPlayed ? "Cancel" : "New Version"}
                                            </motion.span>
                                        </AnimatePresence>
                                    </button>
                                        : ""}
                                </> : (userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") && <button className={`btn ${css.statusButton} ${css.headerActionBtn}`} onClick={() => archivedDocument(docData?.documentId, false)}>Unarchive
                                    {spinner.archived && <i className='ms-2 fa-solid fa-spinner fa-spin'></i>}
                                </button>
                            }
                        </div>
                    </div>
                </div>
        </>
    );
}
